let baseUrl = process.env.VUE_APP_BASE_URL;
let siteUrl = process.env.VUE_APP_SITE_URL;
let apiUrl = process.env.VUE_APP_API_URL;

let _homePath = siteUrl + "/";
let _infoPath = siteUrl + "/info";
let _wealthPath = siteUrl + "/wealth";
let _healthPath = siteUrl + "/health";
let _resultPath = siteUrl + "/result";

if (typeof window._site_params !== "undefined") {
  baseUrl = window._site_params.template + "/";
  siteUrl = window._site_params.ajaxurl;
  apiUrl = window._site_params.ajaxurl;
}

if (
  typeof window._site_params !== "undefined" &&
  typeof window._site_params.app !== "undefined"
) {
  _homePath = window._site_params.app.home;
  _infoPath = window._site_params.app.info;
  _wealthPath = window._site_params.app.wealth;
  _healthPath = window._site_params.app.health;
  _resultPath = window._site_params.app.result;
}

const _goodwealthandhealth = "goodWH_";
const _goodwealthandhealthtogether = "https://goodwealthandhealthtogether.com/";
module.exports = {
  API_PATH: apiUrl,
  THEME_PATH: baseUrl,
  HomePath: _homePath,
  InfoPath: _infoPath,
  WealthPath: _wealthPath,
  HealthPath: _healthPath,
  ResultPath: _resultPath,
  campaignWh: _goodwealthandhealth,
  REST_PATH: {
    getSaleInfo: apiUrl + "/api/getSaleInfo",
    whDataUrl: _goodwealthandhealthtogether + "whdata.php",
    mainWH: _goodwealthandhealthtogether + "whlink.php"
  }
};
